import axios from "axios";

type ApiErrorShape = {
  message?: string;
  error?: string;
  errors?: Array<{ message?: string; field?: string }>;
  messages?: string[]; // alguns backends mandam lista
};

export function extractErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as ApiErrorShape | string | undefined;

    if (typeof data === "string") return data; // backend retornou string pura
    if (!data) return err.message || "Erro desconhecido.";

    // Formatos comuns
    if (data.message) return data.message; // { message: "..." }
    if (data.error) return data.error; // { error: "..." }
    if (Array.isArray(data.messages) && data.messages.length)
      // { messages: ["...", "..."] }
      return data.messages.join("\n");
    if (Array.isArray(data.errors) && data.errors.length) {
      // { errors: [{ message, field }] }
      const first = data.errors[0];
      if (first?.message) return first.message;
      // fallback: concatena mensagens conhecidas
      return data.errors
        .map((e) => [e.field, e.message].filter(Boolean).join(": "))
        .join("\n");
    }

    // último recurso: stringifica o payload
    return JSON.stringify(data);
  }

  // Não é AxiosError
  if (err instanceof Error) return err.message;
  try {
    return JSON.stringify(err);
  } catch {
    return "Erro desconhecido.";
  }
}
